import React from 'react';
import ExternalTemplate from '../ExternalTemplate';
export const ErrorTemplate = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(ExternalTemplate, {
    href: "/",
    bar: {
      show: true,
      onlyLogo: true
    }
  }, children);
};